import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import moment from 'moment';
import Table from './common/Table';
import common from '../utils/Common';
import { exportToCSV, exportToExcel, exportToPDF } from '../utils/Exports';

const FinancialSummary = () => {
  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));
  const [loading, setLoading] = useState(false);
  
  const [orderDetailsModal, setOrderDetailsModal] = useState(false);
  const [logisticsDetailsModal, setLogisticsDetailsModal] = useState(false);
  const [onlineOrdersModal, setOnlineOrdersModal] = useState(false);
  const [offlineOrdersModal, setOfflineOrdersModal] = useState(false);
  const [serviceOrdersModal, setServiceOrdersModal] = useState(false);
  const [logisticsOrdersModal, setLogisticsOrdersModal] = useState(false);
  
  const [orderDetailsData, setOrderDetailsData] = useState([]);
  const [logisticsDetailsData, setLogisticsDetailsData] = useState([]);
  const [onlineOrdersData, setOnlineOrdersData] = useState([]);
  const [offlineOrdersData, setOfflineOrdersData] = useState([]);
  const [serviceOrdersData, setServiceOrdersData] = useState([]);
  const [logisticsOrdersData, setLogisticsOrdersData] = useState([]);
  const [dataDetails, setDataDetails] = useState([]);
  
  const [modalTitle, setModalTitle] = useState('');
  
  const Datadetails = (dataDetails.map((data, index) => ({
    "S.No": index + 1,
      "Customer Name": `${data?.order?.user?.first_name || ''} ${data?.order?.user?.last_name || ''}`.trim(),
      "Reg ID": data?.order?.user?.reg_id || '',
      "Order ID": data?.order?.order_id || '',
      "Order Date": data?.order?.created_at ? moment(data?.order?.created_at).format('DD-MM-YYYY') : '',
      "No Return Date": data?.no_return_date ? moment(data?.no_return_date).format('DD-MM-YYYY') : '',
      "Delivery Status": data?.order_status ? data?.order_status?.charAt(0).toUpperCase() + data?.order_status?.slice(1) : '',
      "Business Name": data?.order?.user?.user_business?.business_name || '',
      "Nature of Business": data?.order?.user?.user_business?.nature_of_business || '',
      "Product Name": data?.product_item ? data?.product_item?.product?.name || 'N/A' : 'N/A',
      "SKU": data?.product_item ? data?.product_item?.product_sku || 'N/A' : 'N/A',
      "Service Name": data?.seller_service ? data?.seller_service?.service_name || 'N/A' : 'N/A',
      "Total Amount": data?.order_price || 0,
      "Taxable Value": data?.taxable_amount || data?.taxable_value || 0,
      "IGST": data?.igst || 0,
      "CGST": data?.cgst || 0,
      "SGST/UTGST": data?.sgst || 0
  })));
  const handleExportDetailCSV = (title) => {
    exportToCSV(Datadetails, title);
}

const handleExportDetailExcel = (title) => {
    exportToExcel(Datadetails, title);
}

const handleExportDetailPDF = (title) => {
    exportToPDF(Datadetails, title);
}

  useEffect(() => {
    fetchFinancialData();
  }, [startDate, endDate]);

  const fetchFinancialData = async () => {
    setLoading(true);
    try {
      let requestData = {
        'start_date': startDate,
        'end_date': endDate,
      };
      let response = await common.apiRequest('post', '/admin/financial-summary', requestData);
      if (response.data.code === 'success') {
        setData(response.data.data);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error('Error fetching financial data:', error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };
  const getExportData = () => {
    if (!data || data.length === 0) return [];
    
    const financialData = data[0];
    
    return [
      {
        "Particular Name": "Net Sales Amount",
        "Amounts (Rs.)": financialData.net_sale_amount,
        "Taxable Value": financialData.net_taxable_amount,
        "IGST": financialData.net_igst_amount,
        "CGST": financialData.net_cgst_amount,
        "SGST/UTGS": financialData.net_sgst_amount,
        "No": ""
      },
      {
        "Particular Name": "Total Orders",
        "Amounts (Rs.)": 0,
        "Taxable Value": 0,
        "IGST": 0,
        "CGST": 0,
        "SGST/UTGS": 0,
        "No": financialData.total_orders_no
      },
      {
        "Particular Name": "Total Online Sales",
        "Amounts (Rs.)": financialData.total_online_order,
        "Taxable Value": financialData.net_taxable_amount_online_orders,
        "IGST": financialData.net_igst_amount_online_orders,
        "CGST": financialData.net_cgst_amount_online_orders,
        "SGST/UTGS": financialData.net_sgst_amount_online_orders,
        "No": ""
      },
      {
        "Particular Name": "Total Offline Sales",
        "Amounts (Rs.)": financialData.total_offline_order,
        "Taxable Value": financialData.taxable_amount_offline_order,
        "IGST": financialData.net_igst_amount_offline_order,
        "CGST": financialData.net_cgst_amount_offline_order,
        "SGST/UTGS": financialData.net_sgst_amount_offline_order,
        "No": ""
      },
      {
        "Particular Name": "Total Services Sales",
        "Amounts (Rs.)": financialData.total_service_order,
        "Taxable Value": financialData.taxable_amount_service_order,
        "IGST": financialData.net_igst_amount_service_order,
        "CGST": financialData.net_cgst_amount_service_order,
        "SGST/UTGS": financialData.net_sgst_amount_service_order,
        "No": ""
      },
      {
        "Particular Name": "Total Logistic Sales",
        "Amounts (Rs.)": financialData.total_logistics_order,
        "Taxable Value": financialData.taxable_amount_logistics_order,
        "IGST": financialData.net_igst_amount_logistics_order,
        "CGST": financialData.net_cgst_amount_logistics_order,
        "SGST/UTGS": financialData.net_sgst_amount_logistics_order,
        "No": ""
      },
      {
        "Particular Name": "Total Commission",
        "Amounts (Rs.)": financialData.total_commission,
        "Taxable Value": financialData.net_commission_taxable_amount,
        "IGST": financialData.net_comm_igst_amount,
        "CGST": financialData.net_comm_cgst_amount,
        "SGST/UTGS": financialData.net_comm_sgst_amount,
        "No": ""
      },
      {
        "Particular Name": "Total Gross Profit",
        "Amounts (Rs.)": financialData.total_gross_profit,
        "Taxable Value": 0,
        "IGST": 0,
        "CGST": 0,
        "SGST/UTGS": 0,
        "No": ""
      },
      {
        "Particular Name": "Net Cash Flow",
        "Amounts (Rs.)": financialData.net_cash_flow,
        "Taxable Value": 0,
        "IGST": 0,
        "CGST": 0,
        "SGST/UTGS": 0,
        "No": ""
      }
    ];
  };
  
  const handleExportCSV = () => {
    exportToCSV(getExportData(), 'Financial Summary Report');
  };
  
  const handleExportExcel = () => {
    exportToExcel(getExportData(), 'Financial Summary Report');
  };
  
  const handleExportPDF = () => {
    exportToPDF(getExportData(), 'Financial Summary Report');
  };
  
  const fetchDetails = async (ids, modalType, title) => {
    if (!ids || (Array.isArray(ids) && ids.length === 0)) {
      alert('No IDs provided for fetching details');
      return;
    }
    setLoading(true);
    try {
      let requestData = {
        'start_date': startDate,
        'end_date': endDate,
        'ids': ids,
        'modalType': modalType,
      };
      let response = await common.apiRequest('post', '/admin/financial-details', requestData);
      if (response.data.code === 'success') {
        const responseData = response.data.data || [];
        setModalTitle(title);
            setDataDetails(responseData);
        switch(modalType) {
          case 'order_details':
            setOrderDetailsData(responseData);
            setOrderDetailsModal(true);
            break;
          case 'logistics_details':
            setLogisticsDetailsData(responseData);
            setLogisticsDetailsModal(true);
            break;
          case 'online_orders':
            setOnlineOrdersData(responseData);
            setOnlineOrdersModal(true);
            break;
          case 'offline_orders':
            setOfflineOrdersData(responseData);
            setOfflineOrdersModal(true);
            break;
          case 'service_orders':
            setServiceOrdersData(responseData);
            setServiceOrdersModal(true);
            break;
          case 'logistics_orders':
            setLogisticsOrdersData(responseData);
            setLogisticsOrdersModal(true);
            break;
          default:
            break;
        }
      } else {
        alert(response.data.error || 'Error fetching details');
      }
    } catch (error) {
      console.error('Error fetching details:', error);
      alert('Error fetching details');
    } finally {
      setLoading(false);
    }
  };

  const toggleOrderDetailsModal = () => {
    setOrderDetailsModal(!orderDetailsModal);
    if (orderDetailsModal) {
      setOrderDetailsData([]);
    }
  };

  const toggleLogisticsDetailsModal = () => {
    setLogisticsDetailsModal(!logisticsDetailsModal);
    if (logisticsDetailsModal) {
      setLogisticsDetailsData([]);
    }
  };

  const toggleOnlineOrdersModal = () => {
    setOnlineOrdersModal(!onlineOrdersModal);
    if (onlineOrdersModal) {
      setOnlineOrdersData([]);
    }
  };

  const toggleOfflineOrdersModal = () => {
    setOfflineOrdersModal(!offlineOrdersModal);
    if (offlineOrdersModal) {
      setOfflineOrdersData([]);
    }
  };

  const toggleServiceOrdersModal = () => {
    setServiceOrdersModal(!serviceOrdersModal);
    if (serviceOrdersModal) {
      setServiceOrdersData([]);
    }
  };

  const toggleLogisticsOrdersModal = () => {
    setLogisticsOrdersModal(!logisticsOrdersModal);
    if (logisticsOrdersModal) {
      setLogisticsOrdersData([]);
    }
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount || 0);
  };

  const columnDefs = [
    {
      header: "Particular Name",
      accessor: "particular_name",
      sortable: false,
      filter: false,
      width: 200,
      render: (row) => (
        <div className="font-weight-bold text-dark">
          {row.particular_name}
        </div>
      )
    },
    {
      header: "Amounts (Rs.)",
      accessor: "amount",
      sortable: true,
      filter: false,
      width: 150,
      render: (row) => (
        <div className="text-right font-weight-bold">
          {formatCurrency(row.amount)}
        </div>
      )
    },
    {
      header: "Taxable Value",
      accessor: "taxable_value",
      sortable: true,
      filter: false,
      width: 150,
      render: (row) => (
        <div className="text-right">
          {formatCurrency(row.taxable_value)}
        </div>
      )
    },
    {
      header: "IGST",
      accessor: "igst",
      sortable: true,
      filter: false,
      width: 120,
      render: (row) => (
        <div className="text-right ">
          {formatCurrency(row.igst)}
        </div>
      )
    },
    {
      header: "CGST",
      accessor: "cgst",
      sortable: true,
      filter: false,
      width: 120,
      render: (row) => (
        <div className="text-right ">
          {formatCurrency(row.cgst)}
        </div>
      )
    },
    {
      header: "SGST/UTGS",
      accessor: "sgst",
      sortable: true,
      filter: false,
      width: 120,
      render: (row) => (
        <div className="text-right">
          {formatCurrency(row.sgst)}
        </div>
      )
    },
    {
      header: "No",
      accessor: "no",
      sortable: true,
      filter: false,
      width: 120,
      render: (row) => (
        <div className="text-right">
          {(row.no)}
        </div>
      )
    },
    {
      header: "Reports",
      accessor: "reports",
      sortable: false,
      filter: false,
      width: 300,
      render: (row) => {
        const financialData = data[0] || {};
        console.log(financialData.net_total_logistics_orders_id)
        switch(row.type) {
          case 'net_sales':
            return (
              <div className="d-flex gap-2">
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => fetchDetails(financialData.net_total_order_id, 'order_details', 'Net Sales - Order Details')}
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Order Details"}
                </button>
                <button
                  className="btn btn-sm "
                  onClick={() => fetchDetails(financialData.net_total_logistics_orders_id, 'logistics_details', 'Net Sales - Logistics Details')}
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Logistics Details"}
                </button>
              </div>
            );
          case 'total_orders':
            return (
              <div className="d-flex gap-2">
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => fetchDetails(financialData.net_total_order_id, 'order_details', 'Total Orders - Order Details')}
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Order Details"}
                </button>
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => fetchDetails(financialData.net_total_logistics_orders_id, 'logistics_details', 'Total Orders - Logistics Details')}
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Logistics Details"}
                </button>
              </div>
            );
          case 'online_sales':
            return (
              <button
                className="btn btn-sm btn-outline-success"
                onClick={() => fetchDetails(financialData.online_order_id, 'online_orders', 'Online Sales Details')}
                disabled={loading}
              >
                {loading ? "Loading..." : "View Details"}
              </button>
            );
          case 'offline_sales':
            return (
              <button
                className="btn btn-sm btn-outline-warning"
                onClick={() => fetchDetails(financialData.offline_order_id, 'offline_orders', 'Offline Sales Details')}
                disabled={loading}
              >
                {loading ? "Loading..." : "View Details"}
              </button>
            );
          case 'service_sales':
            return (
              <button
                className="btn btn-sm btn-outline-info"
                onClick={() => fetchDetails(financialData.service_order_id, 'service_orders', 'Service Sales Details')}
                disabled={loading}
              >
                {loading ? "Loading..." : "View Details"}
              </button>
            );
          case 'logistics_sales':
            return (
              <button
                className="btn btn-sm btn-outline-dark"
                onClick={() => fetchDetails(financialData.logistics_order_id, 'logistics_orders', 'Logistics Sales Details')}
                disabled={loading}
              >
                {loading ? "Loading..." : "View Details"}
              </button>
            );
          case 'commission':
            return (
              <div className="d-flex gap-2">
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => fetchDetails(financialData.net_total_order_id, 'order_details', 'Total Commission - Order Details')}
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Order Details"}
                </button>
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => fetchDetails(financialData.net_total_logistics_orders_id, 'logistics_details', 'Total Commission - Logistics Details')}
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Logistics Details"}
                </button>
              </div>
            );
          case 'gross_profit':
            return (
              <div className="d-flex gap-2">
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => fetchDetails(financialData.net_total_order_id, 'order_details', 'Total Gross Profit - Order Details')}
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Order Details"}
                </button>
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => fetchDetails(financialData.net_total_logistics_orders_id, 'logistics_details', 'Total Gross Profit - Logistics Details')}
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Logistics Details"}
                </button>
              </div>
            );
          case 'cash_flow':
            return (
              <div className="d-flex gap-2">
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => fetchDetails(financialData.net_total_order_id, 'order_details', 'Net Cash Flow - Order Details')}
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Order Details"}
                </button>
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => fetchDetails(financialData.net_total_logistics_orders_id, 'logistics_details', 'Net Cash Flow - Logistics Details')}
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Logistics Details"}
                </button>
              </div>
            );
          default:
            return (
              <button
                className="btn btn-sm btn-outline-primary"
                onClick={() => fetchDetails([], 'order_details', 'View Details')}
                disabled={loading}
              >
                {loading ? "Loading..." : "View Details"}
              </button>
            );
        }
      }
    }
  ];

  const getTableData = () => {
    if (!data || data.length === 0) return [];
    
    const financialData = data[0];
    
    return [
      {
        particular_name: "Net Sales Amount",
        amount: financialData.net_sale_amount,
        taxable_value: financialData.net_taxable_amount,
        igst: financialData.net_igst_amount,
        cgst: financialData.net_cgst_amount,
        sgst: financialData.net_sgst_amount,
        type: "net_sales"
      },
      {
        particular_name: "Total Orders",
        amount: 0,
        taxable_value: 0,
        igst: 0,
        cgst: 0,
        sgst: 0,
        no: financialData.total_orders_no,
        type: "total_orders"
      },
      {
        particular_name: "Total Online Sales",
        amount: financialData.total_online_order,
        taxable_value: financialData.net_taxable_amount_online_orders,
        igst: financialData.net_igst_amount_online_orders,
        cgst: financialData.net_cgst_amount_online_orders,
        sgst: financialData.net_sgst_amount_online_orders,
        type: "online_sales"
      },
      {
        particular_name: "Total Offline Sales",
        amount: financialData.total_offline_order,
        taxable_value: financialData.taxable_amount_offline_order,
        igst: financialData.net_igst_amount_offline_order,
        cgst: financialData.net_cgst_amount_offline_order,
        sgst: financialData.net_sgst_amount_offline_order,
        type: "offline_sales"
      },
      {
        particular_name: "Total Services Sales",
        amount: financialData.total_service_order,
        taxable_value: financialData.taxable_amount_service_order,
        igst: financialData.net_igst_amount_service_order,
        cgst: financialData.net_cgst_amount_service_order,
        sgst: financialData.net_sgst_amount_service_order,
        type: "service_sales"
      },
      {
        particular_name: "Total Logistic Sales",
        amount: financialData.total_logistics_order,
        taxable_value: financialData.taxable_amount_logistics_order,
        igst: financialData.net_igst_amount_logistics_order,
        cgst: financialData.net_cgst_amount_logistics_order,
        sgst: financialData.net_sgst_amount_logistics_order,
        type: "logistics_sales"
      },
      {
        particular_name: "Total Commission",
        amount: financialData.total_commission,
        taxable_value: financialData.net_commission_taxable_amount,
        igst: financialData.net_comm_igst_amount,
        cgst: financialData.net_comm_cgst_amount,
        sgst: financialData.net_comm_sgst_amount,
        type: "commission"
      },
      {
        particular_name: "Total Gross Profit",
        amount: financialData.total_gross_profit,
        taxable_value: 0,
        igst: 0,
        cgst: 0,
        sgst: 0,
        type: "gross_profit"
      },
      {
        particular_name: "Net Cash Flow",
        amount: financialData.net_cash_flow,
        taxable_value: 0,
        igst: 0,
        cgst: 0,
        sgst: 0,
        type: "cash_flow"
      }
    ];
  };

  const detailsColumnDefs = [
    {
      header: "S.No",
      accessor: "s_no",
      render: (_, index) => index + 1,
      width: 80
    },
    {
      header: "Customer Name",
      accessor: "customer_name",
      sortable: true,
      filter: true,
      flex: 1,
      render: (row) => `${row?.order?.user?.first_name} ${row?.order?.user?.last_name}`
    },
    {
      header: "Reg ID",
      accessor: "reg_id",
      sortable: true,
      filter: true,
      flex: 1,
      render: (row) => row?.order?.user?.reg_id
    },
    {
      header: "Order ID",
      accessor: "order_id",
      sortable: true,
      filter: true,
      flex: 1,
      render: (row) => row?.order?.order_id
    },
    {
      header: "Order Date",
      accessor: "order_date",
      sortable: true,
      filter: true,
      flex: 1,
      render: (row) => {
        return moment(row?.order?.created_at).format('DD-MM-YYYY');
      }
    },
    {
      header: "No Return Date",
      accessor: "no_return_date",
      sortable: true,
      filter: true,
      flex: 1,
      render: (row) => moment(row?.no_return_date).format('DD-MM-YYYY')
    },
    {
      header: "Delivery Status",
      accessor: "order_status",
      sortable: true,
      filter: true,
      flex: 1,
      render: (row) => row?.order_status?.charAt(0).toUpperCase() + row?.order_status?.slice(1)
    },
    {
      header: "Business Name",
      accessor: "business_name",
      sortable: true,
      filter: true,
      flex: 1,
      render: (row) => row?.order?.user?.user_business?.business_name
    },
    {
      header: "Nature of Business",
      accessor: "nature_of_business",
      sortable: true,
      filter: true,
      flex: 1,
      render: (row) => row?.order?.user?.user_business?.nature_of_business
    },
    {
      header: "Product Name",
      accessor: "product_name",
      sortable: true,
      filter: true,
      flex: 1,
      render: (row) => row?.product_item ? row?.product_item?.product.name : 'N/A'
    },
    {
      header: "SKU",
      accessor: "product_sku",
      sortable: true,
      filter: true,
      flex: 1,
      render: (row) => row?.product_item ? row?.product_item?.product_sku : 'N/A'
    },
    {
      header: "Service Name",
      accessor: "service_name",
      sortable: true,
      filter: true,
      flex: 1,
      render: (row) => row?.seller_service ? row?.seller_service?.service_name : 'N/A'
    },
    {
      header: "Total Amount",
      accessor: "order_price",
      sortable: true,
      filter: false,
      flex: 1,
      render: (row) => formatCurrency(row?.order_price)
    },
    {
      header: "Taxable Value",
      accessor: "taxable_amount",
      sortable: true,
      filter: false,
      flex: 1,
      render: (row) => formatCurrency(row?.taxable_amount?row?.taxable_amount:row?.taxable_value)
    },
    {
      header: "IGST",
      accessor: "igst",
      sortable: true,
      filter: false,
      flex: 1,
      render: (row) => row.igst ? formatCurrency(row.igst) : '0.00'
    },
    {
      header: "CGST",
      accessor: "cgst",
      sortable: true,
      filter: false,
      flex: 1,
      render: (row) => row.cgst ? formatCurrency(row.cgst) : '0.00'
    },
    {
      header: "SGST/UTGST",
      accessor: "sgst",
      sortable: true,
      filter: false,
      flex: 1,
      render: (row) => row.sgst ? formatCurrency(row.sgst) : '0.00'
    }
  ];

  return (
    <>
      <div className="col-md-12">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
  <h4 className="card-title mb-0">Financial Summary</h4>
  <div className="d-flex gap-2">
    <button className='btn btn-sm btn-outline-primary' onClick={handleExportCSV}>
      Export to CSV
    </button>
    <button className='btn btn-sm btn-outline-success' onClick={handleExportExcel}>
      Export to Excel
    </button>
    <button className='btn btn-sm btn-outline-danger' onClick={handleExportPDF}>
      Export to PDF
    </button>
  </div>
</div>
          <div className="card-body">
            <div className='row mb-4'>
              <div className='col-md-4 row'>
                <label className="col-md-3 col-form-label" htmlFor="Date-from">From:</label>
                <div className="col-md-9">
                  <input 
                    type='date' 
                    value={startDate} 
                    onChange={handleStartDateChange} 
                    className="form-control" 
                    id="Date-from" 
                    name="Date-from"
                  />
                </div>
              </div>
              <div className='col-md-4 row'>
                <label className="col-md-3 col-form-label" htmlFor="Date-to">To:</label>
                <div className="col-md-9">
                  <input 
                    type='date' 
                    value={endDate} 
                    onChange={handleEndDateChange} 
                    className="form-control" 
                    id="Date-to" 
                    name="Date-to"
                  />
                </div>
              </div>
            </div>
            
            {loading ? (
              <div className="text-center py-4">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <div className="table-responsive">
                <div className="ag-theme-alpine" style={{ height: 600, width: '100%' }}>
                  <Table
                    data={getTableData()}
                    columns={columnDefs}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Order Details Modal */}
        <Modal isOpen={orderDetailsModal} toggle={toggleOrderDetailsModal} size="xl">
  <ModalHeader toggle={toggleOrderDetailsModal}>
    <div className="d-flex justify-content-between align-items-center w-100">
      <div>
        {modalTitle} ({orderDetailsData.length} records)
      </div>
      <div className="d-flex gap-2">
        <button className='btn btn-sm btn-outline-primary' onClick={() => handleExportDetailCSV("Order Details")}>
          Export to CSV
        </button>
        <button className='btn btn-sm btn-outline-success' onClick={() => handleExportDetailExcel("Order Details")}>
          Export to Excel
        </button>
        <button className='btn btn-sm btn-outline-danger' onClick={() => handleExportDetailPDF("Order Details")}>
          Export to PDF
        </button>
      </div>
    </div>
  </ModalHeader>
  <ModalBody>
    {orderDetailsData.length > 0 ? (
      <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
        <Table
          data={orderDetailsData}
          columns={detailsColumnDefs}
        />
      </div>
    ) : (
      <div className="text-center py-4">
        <p className="text-muted">No details available for the selected period</p>
      </div>
    )}
  </ModalBody>
</Modal>

{/* Logistics Details Modal */}
<Modal isOpen={logisticsDetailsModal} toggle={toggleLogisticsDetailsModal} size="xl">
  <ModalHeader toggle={toggleLogisticsDetailsModal}>
    <div className="d-flex justify-content-between align-items-center w-100">
      <div>
        {modalTitle} ({logisticsDetailsData.length} records)
      </div>
      <div className="d-flex gap-2">
        <button className='btn btn-sm btn-outline-primary' onClick={() => handleExportDetailCSV("Logistics Details")}>
          Export to CSV
        </button>
        <button className='btn btn-sm btn-outline-success' onClick={() => handleExportDetailExcel("Logistics Details")}>
          Export to Excel
        </button>
        <button className='btn btn-sm btn-outline-danger' onClick={() => handleExportDetailPDF("Logistics Details")}>
          Export to PDF
        </button>
      </div>
    </div>
  </ModalHeader>
  <ModalBody>
    {logisticsDetailsData.length > 0 ? (
      <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
        <Table
          data={logisticsDetailsData}
          columns={detailsColumnDefs}
        />
      </div>
    ) : (
      <div className="text-center py-4">
        <p className="text-muted">No logistics details available for the selected period</p>
      </div>
    )}
  </ModalBody>
</Modal>

{/* Online Orders Modal */}
<Modal isOpen={onlineOrdersModal} toggle={toggleOnlineOrdersModal} size="xl">
  <ModalHeader toggle={toggleOnlineOrdersModal}>
    <div className="d-flex justify-content-between align-items-center w-100">
      <div>
        {modalTitle} ({onlineOrdersData.length} records)
      </div>
      <div className="d-flex gap-2">
        <button className='btn btn-sm btn-outline-primary' onClick={() => handleExportDetailCSV("Online Orders")}>
          Export to CSV
        </button>
        <button className='btn btn-sm btn-outline-success' onClick={() => handleExportDetailExcel("Online Orders")}>
          Export to Excel
        </button>
        <button className='btn btn-sm btn-outline-danger' onClick={() => handleExportDetailPDF("Online Orders")}>
          Export to PDF
        </button>
      </div>
    </div>
  </ModalHeader>
  <ModalBody>
    {onlineOrdersData.length > 0 ? (
      <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
        <Table
          data={onlineOrdersData}
          columns={detailsColumnDefs}
        />
      </div>
    ) : (
      <div className="text-center py-4">
        <p className="text-muted">No online orders available for the selected period</p>
      </div>
    )}
  </ModalBody>
</Modal>

{/* Offline Orders Modal */}
<Modal isOpen={offlineOrdersModal} toggle={toggleOfflineOrdersModal} size="xl">
  <ModalHeader toggle={toggleOfflineOrdersModal}>
    <div className="d-flex justify-content-between align-items-center w-100">
      <div>
        {modalTitle} ({offlineOrdersData.length} records)
      </div>
      <div className="d-flex gap-2">
        <button className='btn btn-sm btn-outline-primary' onClick={() => handleExportDetailCSV("Offline Orders")}>
          Export to CSV
        </button>
        <button className='btn btn-sm btn-outline-success' onClick={() => handleExportDetailExcel("Offline Orders")}>
          Export to Excel
        </button>
        <button className='btn btn-sm btn-outline-danger' onClick={() => handleExportDetailPDF("Offline Orders")}>
          Export to PDF
        </button>
      </div>
    </div>
  </ModalHeader>
  <ModalBody>
    {offlineOrdersData.length > 0 ? (
      <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
        <Table
          data={offlineOrdersData}
          columns={detailsColumnDefs}
        />
      </div>
    ) : (
      <div className="text-center py-4">
        <p className="text-muted">No offline orders available for the selected period</p>
      </div>
    )}
  </ModalBody>
</Modal>

{/* Service Orders Modal */}
<Modal isOpen={serviceOrdersModal} toggle={toggleServiceOrdersModal} size="xl">
  <ModalHeader toggle={toggleServiceOrdersModal}>
    <div className="d-flex justify-content-between align-items-center w-100">
      <div>
        {modalTitle} ({serviceOrdersData.length} records)
      </div>
      <div className="d-flex gap-2">
        <button className='btn btn-sm btn-outline-primary' onClick={() => handleExportDetailCSV("Service Orders")}>
          Export to CSV
        </button>
        <button className='btn btn-sm btn-outline-success' onClick={() => handleExportDetailExcel("Service Orders")}>
          Export to Excel
        </button>
        <button className='btn btn-sm btn-outline-danger' onClick={() => handleExportDetailPDF("Service Orders")}>
          Export to PDF
        </button>
      </div>
    </div>
  </ModalHeader>
  <ModalBody>
    {serviceOrdersData.length > 0 ? (
      <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
        <Table
          data={serviceOrdersData}
          columns={detailsColumnDefs}
        />
      </div>
    ) : (
      <div className="text-center py-4">
        <p className="text-muted">No service orders available for the selected period</p>
      </div>
    )}
  </ModalBody>
</Modal>

{/* Logistics Orders Modal */}
<Modal isOpen={logisticsOrdersModal} toggle={toggleLogisticsOrdersModal} size="xl">
  <ModalHeader toggle={toggleLogisticsOrdersModal}>
    <div className="d-flex justify-content-between align-items-center w-100">
      <div>
        {modalTitle} ({logisticsOrdersData.length} records)
      </div>
      <div className="d-flex gap-2">
        <button className='btn btn-sm btn-outline-primary' onClick={() => handleExportDetailCSV("Logistics Orders")}>
          Export to CSV
        </button>
        <button className='btn btn-sm btn-outline-success' onClick={() => handleExportDetailExcel("Logistics Orders")}>
          Export to Excel
        </button>
        <button className='btn btn-sm btn-outline-danger' onClick={() => handleExportDetailPDF("Logistics Orders")}>
          Export to PDF
        </button>
      </div>
    </div>
  </ModalHeader>
  <ModalBody>
    {logisticsOrdersData.length > 0 ? (
      <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
        <Table
          data={logisticsOrdersData}
          columns={detailsColumnDefs}
        />
      </div>
    ) : (
      <div className="text-center py-4">
        <p className="text-muted">No logistics orders available for the selected period</p>
      </div>
    )}
  </ModalBody>
</Modal>
      </div>
    </>
  );
};

export default FinancialSummary;